import { apiCall } from "../../../_utils";
import { apiUrls } from "../../../_constants";

export const currencyService = {
  getAllCurrencies,
  addCurrency,
  getCurrency
};

function getAllCurrencies() {
  return apiCall("GET", apiUrls.currencies.base);
}

function addCurrency(request) {
  const method = request && request.id ? "PUT" : "POST";
  return apiCall(method, apiUrls.currencies.base, request);
}

function getCurrency(id) {
  return apiCall("GET", `${apiUrls.currencies.base}/${id}`);
}
